import { defineMessages } from 'react-intl';

export default defineMessages({
  dropHere: 'Upuść plik tutaj lub ',
  upload: 'załącz',
  fromHardDrive: ' z dysku',
});
